
export const defaultMemberEnrollment = {
  phoneNumber : '',
  utilityAccountNumber : '',
  zipCode : '',
  reason: ''
}

// Need to set these when we click on edit
export const editMemberEnrollment = {
  phoneNumber : '',
  utilityAccountNumber : '',
  zipCode : '',
  reason: ''
}
